import { useDisableDigitalPracticeModal } from './use-disable-digital-practice-modal';
import { useRequestHomeAccessModal } from './use-request-home-access-modal';

type Props = {
  hasClassroomDigitalPracticeAccess: boolean;
};

type UseDigitalPracticeAccessReturn = {
  isDisableModalOpen: boolean;
  isDisablePending: boolean;
  isRequestModalOpen: boolean;
  handleCloseDisableModal: () => void;
  handleCloseRequestModal: () => void;
  handleConfirmDisable: () => void;
  handleContactAdvisor: () => void;
  handleOpenModal: () => void;
};

function useDigitalPracticeAccess({
  hasClassroomDigitalPracticeAccess,
}: Props): UseDigitalPracticeAccessReturn {
  const {
    isModalOpen: isRequestModalOpen,
    handleCloseModal: handleCloseRequestModal,
    handleContactAdvisor,
    handleOpenModal: handleOpenRequestModal,
  } = useRequestHomeAccessModal();

  const {
    isModalOpen: isDisableModalOpen,
    handleCloseModal: handleCloseDisableModal,
    handleConfirm: handleConfirmDisable,
    handleOpenModal: handleOpenDisableModal,
    isPending: isDisablePending,
  } = useDisableDigitalPracticeModal();

  const handleOpenModal = (): void => {
    if (hasClassroomDigitalPracticeAccess) {
      handleOpenDisableModal();
      return;
    }

    handleOpenRequestModal();
  };

  return {
    isDisableModalOpen,
    isRequestModalOpen,
    isDisablePending,
    handleCloseDisableModal,
    handleCloseRequestModal,
    handleConfirmDisable,
    handleContactAdvisor,
    handleOpenModal,
  };
}

export { useDigitalPracticeAccess };
